import * as React from "react";
import LoginService from "../../service/login/loginService";
import EdButton from "../../generic/edButton";
import {IPContext} from "../infinityPlan";
import gtmService from "../../service/gtmService";

export default function PageFooterDock() {
    const [loggedIn] = React.useState<boolean>(LoginService.isLoggedIn());
    const [infinityPlanFlag] = React.useState<boolean | undefined>(LoginService.getAccData("accs")?.mfInf);
    const {dockToBtm, saveLead, setShowModal} = React.useContext(IPContext);
    return (

        <ul className="plans_grid">
            {!infinityPlanFlag && saveLead && (
                <li id={"plans_n_pricing_ftr"}
                    className={"plans_n_pricing_ftr grid_cols" + (dockToBtm ? " fixed" : "")}>
                    <label className="info_txt">Exclusive benefits on brokerage and other charges of upto ₹8 Lakh,
                        subscribe to INFINITY</label>

                    <EdButton
                        btnTyp="primary"
                        value="I’m Interested"
                        className="ed_button ib primary button"
                        onClick={() => {
                            gtmService({
                                event: "event Infinity_Subscription_Program",
                                category: "Infinity Subscription",
                                action: "Footer_button",
                                labelUrlR: "I'm Interested"
                            });
                            loggedIn ? saveLead() : setShowModal(true);
                        }}
                        slim
                    />


                </li>
            )}
        </ul>
    )
}
